module.exports = __webpack_public_path__ + "static/media/preference-profession-designer.b20be151.png";